module.exports = __webpack_public_path__ + "static/media/cq_editor_sottolineato.4b169ab6.svg";